export default "__VITE_ASSET__DZS7PZcF__"